// extracted by mini-css-extract-plugin
module.exports = {"container":"shop-by-brand-thumbnail_container__kmJH_","text":"shop-by-brand-thumbnail_text__Pbbnl"};